import { Outlet } from 'react-router-dom';
import { TooltipProvider } from '@employer-on-record/ui';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

export default function Layout() {
	return (
		<TooltipProvider>
			<div className="flex min-h-screen bg-background">
				<Sidebar />
				<div className="flex-1 min-w-0 flex flex-col">
					<Topbar />
					<div className="p-7 max-w-[1400px] w-full">
						<Outlet />
					</div>
				</div>
			</div>
		</TooltipProvider>
	);
}
